$(document).ready(function() {
  
  $('.pop-up .close').click(function(){
    $('.pop-up').removeClass('open');
  });

  if (window.location.pathname === '/') {
    setTimeout(function() {
      $('.pop-up').addClass('open');
    }, 3000);
  }

    var toggleNav = $('.site-nav__open');

    toggleNav.on('click', function() {
      $('.site-nav--mobile').toggleClass('is-open');
      $('body').toggleClass('menu-open');
    })




    var widthScreen = $(window).width();

    var $slickRea = $('.js-carousel');
    var $slickCards = $('.js-carousel-cards');
    var $prev = $('.js-nav__prev');
    var $next = $('.js-nav__next');

    function showSliderScreen($widthScreen) {
      if ($widthScreen) {
          if (!$slickRea.hasClass('slick-initialized')) {
            $slickRea.slick({
              infinite: false,
              arrows: true,
              dots: true,
              slidesPerRow: 3,
              rows: 2,
              prevArrow: $prev,
              nextArrow: $next,
              mobileFirst: true,
              responsive: [
                {
                  breakpoint: 1,
                  settings: {
                    slidesPerRow: 2,
                    arrows: false
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesPerRow: 3,
                  }
                },
              ]
            });
          }
        } else {
          if ($slickRea.hasClass('slick-initialized')) {
            $slickRea.slick('unslick')
          }
        }

      if ($widthScreen <= "1199") {
        if (!$slickCards.hasClass('slick-initialized')) {
          $slickCards.slick({
            infinite: false,
            arrows: false,
            dots: true,
            mobileFirst: true,
            responsive: [
              {
                breakpoint: 1,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
              },
              {
                breakpoint: 543,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
              },
            ]
          }).on('setPosition', function (event, slick) {
            slick.$slides.css('height', slick.$slideTrack.height() + 'px');
        });;
        }
      } else {
        if ($slickCards.hasClass('slick-initialized')) {
          $slickCards.slick('unslick')
        }
      }
    }

    $(window).ready(showSliderScreen(widthScreen)).resize(
      function() {
        var widthScreen = $(window).width();
        showSliderScreen(widthScreen)
      }
    );


    // MENU FIX SCROLL
    $(function() {
      //caches a jQuery object containing the header element
      var header = $("#nav_header");
      var marginTopHeader = $(".site-nav__top");
      $(window).scroll(function() {
          var scroll = $(window).scrollTop();
  
          if (scroll >= 176) {
              header.addClass("active");
              marginTopHeader.addClass("active");
          } else {
              header.removeClass("active");
              marginTopHeader.removeClass("active");
          }
      });
  });

  //TAB EXPAND

  $('.accordion a').click(function(){
    $(this).toggleClass('active');
    $(this).next('.content').slideToggle(400);
   });
});